
import { Auth } from '../slices';
import { CountryListFilter, CurrentUser, ListState, Login, OrganizationListFilter, OrganizationListItem, ListQuery, Register, SuccessResponse } from '../types';
import { abibApi, tags, methods } from './';

export const apiAuthentication = abibApi.injectEndpoints({
  endpoints: (builder) => ({
    login: builder.mutation<Auth, Login>({
      query: (loginData) => ({
        url: '/login',
        method: methods.POST,
        body: loginData,
      }),
      invalidatesTags: [tags.currentUser],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    logout: builder.mutation<any, void>({
      query: () => ({
        url: '/logout',
        method: methods.POST,
        body: {},
      }),
      invalidatesTags: [tags.currentUser],
    }),
    register: builder.mutation<Auth, Register>({
      query: (registerData) => ({
        url: '/register',
        method: methods.POST,
        body: registerData,
      }),
      invalidatesTags: [tags.currentUser],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    updateCurrentUser: builder.mutation<any, { name: string }>({
      query: (data) => ({
        url: '/currentUser',
        method: methods.PUT,
        body: data,
      }),
      invalidatesTags: [tags.currentUser],
    }),
    updatePassword: builder.mutation<any, { current_password: string; new_password: string; new_password_confirmation: string; }>({
      query: (data) => ({
        url: '/currentUser',
        method: methods.PUT,
        body: data,
      }),
      invalidatesTags: [tags.currentUser],
    }),
    getCurrentUser: builder.query<CurrentUser, void>({
      query: () => {
        return {
          method: methods.GET,
          url: `/currentUser`,
        };
      },
      providesTags: (currentUser) => [{ type: tags.currentUser, id: currentUser?.id }],
      transformResponse: ({ data }, meta, arg) => data,
    }),
    getCurrentUserOrganizationList: builder.query<ListState<OrganizationListItem, OrganizationListFilter>, ListQuery<OrganizationListFilter>>({
      query: ({ page, perPage, filter }) => {
        return {
          method: methods.GET,
          url: `/currentUser/orgs?page=${page || 1}&perPage=${perPage || 10}&filter=${JSON.stringify(filter || {})}`,
        };
      },
      providesTags: (result, error, params) => [tags.currentUser, tags.organizationList],
      transformResponse: (response: SuccessResponse, meta, { page, perPage, filter }) => {
        const { data, meta: { links, path, ...pagination } } = response;
        return {
          filter: filter,
          items: data,
          pagination: pagination,
        }
      },
    }),
  }),
  overrideExisting: false,
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useLoginMutation,
  useLogoutMutation,
  useRegisterMutation,

  useUpdatePasswordMutation,

  useGetCurrentUserQuery,
  useLazyGetCurrentUserQuery,

  useGetCurrentUserOrganizationListQuery,
  useLazyGetCurrentUserOrganizationListQuery,
} = apiAuthentication;
